var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsuario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.50005C8.49456 7.50005 9.44839 7.10496 10.1517 6.4017C10.8549 5.69843 11.25 4.74461 11.25 3.75005C11.25 2.75548 10.8549 1.80166 10.1517 1.0984C9.44839 0.395134 8.49456 4.57764e-05 7.5 4.57764e-05C6.50544 4.57764e-05 5.55161 0.395134 4.84835 1.0984C4.14509 1.80166 3.75 2.75548 3.75 3.75005C3.75 4.74461 4.14509 5.69843 4.84835 6.4017C5.55161 7.10496 6.50544 7.50005 7.5 7.50005ZM10 3.75005C10 4.41309 9.73661 5.04897 9.26777 5.51781C8.79893 5.98665 8.16304 6.25005 7.5 6.25005C6.83696 6.25005 6.20107 5.98665 5.73223 5.51781C5.26339 5.04897 5 4.41309 5 3.75005C5 3.087 5.26339 2.45112 5.73223 1.98228C6.20107 1.51344 6.83696 1.25005 7.5 1.25005C8.16304 1.25005 8.79893 1.51344 9.26777 1.98228C9.73661 2.45112 10 3.087 10 3.75005ZM15 13.75C15 15 13.75 15 13.75 15H1.25C1.25 15 0 15 0 13.75C0 12.5 1.25 8.75005 7.5 8.75005C13.75 8.75005 15 12.5 15 13.75ZM13.75 13.745C13.7487 13.4375 13.5575 12.5125 12.71 11.665C11.895 10.85 10.3612 10 7.5 10C4.6375 10 3.105 10.85 2.29 11.665C1.4425 12.5125 1.2525 13.4375 1.25 13.745H13.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuario);
export default __webpack_public_path__ + "static/media/usuario.ede89d2fbced6c9ab21d08c4d272929f.svg";
export { ForwardRef as ReactComponent };